<template>
  <div class="banner" :style="{backgroundImage: 'url(' + screenConfiguration.topmarketinglinetext + ')'}">
    
  </div>
</template>

<script>
  import store from '@/store'

  import Screen from '@/components/mixins/Screen'

  export default {
    name: 'banner',
    props: [
      'category',
      'fullscreen'
    ],
    mixins: [
      Screen
    ],

    components: {
    },

    data () {
      return {
      }
    },

    computed: {
      screenConfiguration () {
        return store.getters['cduState/getScreenConfiguration']
      },
      isFullscreen () {
        return this.fullscreen !== undefined
      }
    },

    methods: {
    },

    mounted () {
    },

    destroyed () {
    },

    watch: {
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
  .banner
    width: 100%
    height: 100%
    background-repeat: no-repeat
    background-size: contain
    background-position: center
</style>



// WEBPACK FOOTER //
// src/components/cdu/headlines/banner.vue